import config from '../config';

export default function PageLogo() {
  return (
        <a href='/'>
            <div className='flex justify-center items-center'>
                <img src="/logo.png" alt={config.appName} title={config.appName} className="w-12 h-12 mb-4 duration-300 hover:scale-105" />
                <h2 className="text-2xl font-bold mb-4 ml-1 text-center text-orange-400 font-serif italic duration-300 hover:scale-105">{config.appName}</h2>
            </div>
        </a>
    )
}

